export const SOCIAL_TWITTER = "https://twitter.com/VoxelArchitects";
export const SOCIAL_LINKEDIN =
  "https://www.linkedin.com/company/voxelarchitects";
export const SOCIAL_INSTAGRAM = "https://instagram.com/voxel.architects";
export const SOCIAL_MEDIUM = "https://medium.com/voxelarchitects";
